export default "__VITE_ASSET__84d3bcb5__"